import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Marketday } from './marketday.model';
import { MarketdayService } from './marketday.service';
@Injectable()
export class MarketdayPopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private marketdayService: MarketdayService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.marketdayService.find(id).subscribe((marketday) => {
                marketday.startTime = this.datePipe
                    .transform(marketday.startTime, 'yyyy-MM-ddThh:mm');
                marketday.endTime = this.datePipe
                    .transform(marketday.endTime, 'yyyy-MM-ddThh:mm');
                marketday.buildingStartTime = this.datePipe
                    .transform(marketday.buildingStartTime, 'yyyy-MM-ddThh:mm');
                marketday.dismantlingEndTime = this.datePipe
                    .transform(marketday.dismantlingEndTime, 'yyyy-MM-ddThh:mm');
                marketday.startTimeWinter = this.datePipe
                    .transform(marketday.startTimeWinter, 'yyyy-MM-ddThh:mm');
                marketday.endTimeWinter = this.datePipe
                    .transform(marketday.endTimeWinter, 'yyyy-MM-ddThh:mm');
                marketday.buildingStartTimeWinter = this.datePipe
                    .transform(marketday.buildingStartTimeWinter, 'yyyy-MM-ddThh:mm');
                marketday.dismantlingEndTimeWinter = this.datePipe
                    .transform(marketday.dismantlingEndTimeWinter, 'yyyy-MM-ddThh:mm');
                marketday.updated = this.datePipe
                    .transform(marketday.updated, 'yyyy-MM-ddThh:mm');
                marketday.created = this.datePipe
                    .transform(marketday.created, 'yyyy-MM-ddThh:mm');
                this.marketdayModalRef(component, marketday);
            });
        } else {
            return this.marketdayModalRef(component, new Marketday());
        }
    }

    marketdayModalRef(component: Component, marketday: Marketday): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.marketday = marketday;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketday/marketday-popup.service.ts